///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.events = abcsetup.events || {};
abcsetup.events.manage = abcsetup.events.manage || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.events.manage = {
    init: function () {
        abcsetup.setTitle('Manage Event Items');

        abcsetup.events.common.init();
    },
}
